/* AUTOGENERATED by `python -m app.cli recalc-presets`.
 * Source of truth: backend/app/services/hero_presets.py.
 * To change forms or add a preset: edit hero_presets.py, then re-run
 * the CLI command. Do not edit this file by hand — your changes will be
 * overwritten on the next recalc.
 */

import { EnglishLevel, Experience, Language, Region } from './constants.js';

export const HERO_PRESETS = [
  {
    id: "frontend",
    roleLabel: "Frontend-разработчик",
    min: 195000,
    max: 280000,
    percentile: 0.405,
    predictor: "mock-v1",
    recs: [{ slug: "next-js", label: "Next.js" }, { slug: "redux", label: "Redux" }],
    form: {
      role: "developer",
      experience: Experience.Y3_5,
      skills: ["react", "typescript", "javascript", "css", "git"],
      region: Region.MSK,
      remote: true,
      employment: "full",
      education: "",
      languages: [{ language: Language.EN, level: EnglishLevel.B1 }],
    },
  },
  {
    id: "backend",
    roleLabel: "Backend-разработчик",
    min: 200000,
    max: 290000,
    percentile: 0.423,
    predictor: "mock-v1",
    recs: [{ slug: "kafka", label: "Kafka" }, { slug: "redis", label: "Redis" }],
    form: {
      role: "developer",
      experience: Experience.Y3_5,
      skills: ["python", "postgresql", "docker", "fastapi", "git"],
      region: Region.MSK,
      remote: true,
      employment: "full",
      education: "",
      languages: [{ language: Language.EN, level: EnglishLevel.B2 }],
    },
  },
  {
    id: "devops",
    roleLabel: "DevOps-инженер",
    min: 220000,
    max: 315000,
    percentile: 0.468,
    predictor: "mock-v1",
    recs: [{ slug: "ansible", label: "Ansible" }, { slug: "prometheus", label: "Prometheus" }],
    form: {
      role: "devops",
      experience: Experience.Y3_5,
      skills: ["kubernetes", "docker", "terraform", "ci-cd", "linux"],
      region: Region.MSK,
      remote: true,
      employment: "full",
      education: "",
      languages: [{ language: Language.EN, level: EnglishLevel.B2 }],
    },
  },
  {
    id: "qa",
    roleLabel: "QA-инженер",
    min: 140000,
    max: 200000,
    percentile: 0.248,
    predictor: "mock-v1",
    recs: [{ slug: "jenkins", label: "Jenkins" }, { slug: "jira", label: "Jira" }],
    form: {
      role: "qa-engineer",
      experience: Experience.Y1_3,
      skills: ["python", "selenium", "postman", "sql", "pytest"],
      region: Region.MSK,
      remote: false,
      employment: "full",
      education: "",
      languages: [{ language: Language.EN, level: EnglishLevel.B1 }],
    },
  },
];

/** Convenience: percentile float -> "top X%" integer, clamped to [1, 99]. */
export function topPercentLabel(percentile) {
  const top = Math.round((1 - percentile) * 100);
  return Math.min(99, Math.max(1, top));
}
